import { render } from "./package-upload.vue?vue&type=template&id=e98d5608&ts=true&lang=pug"
import script from "./package-upload.vue?vue&type=script&lang=ts"
export * from "./package-upload.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__